// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._tWHtY {\n    z-index: 5;\n}", "",{"version":3,"sources":["webpack://src/Components/MobileScreens/dashboard.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd","sourcesContent":["._tWHtY {\n    z-index: 5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
